import { Routes } from '@angular/router';
import { TeamComponent } from './team.component';

export default [
    {
        path     : '',
        component: TeamComponent,
    },
    
] as Routes;
